import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdClose } from 'react-icons/md';
import './TrustProSyncBanner.css';

const DISMISSED_KEY = 'trustpro-sync-banner-dismissed';

const TrustProSyncBanner = ({ show }) => {
    const { t } = useTranslation();
    const [dismissed, setDismissed] = useState(
        () => sessionStorage.getItem(DISMISSED_KEY) === 'true'
    );

    const handleDismiss = () => {
        sessionStorage.setItem(DISMISSED_KEY, 'true');
        setDismissed(true);
    };

    if (!show || dismissed) return null;

    return (
        <div className="trustpro-sync-banner">
            <MdClose className="close-banner" onClick={handleDismiss} />
            <div className="trustpro-sync-banner-content">
                <span className="trustpro-sync-banner-icon" role="img" aria-label="Warning">⚠️</span>
                <span>
                    <strong>{t('documents.trustpro-sync-required-title')}</strong>:{' '}
                    {t('documents.trustpro-sync-required-message')}{' '}
                    <Link to="/certificates?tab=FirmaRemota">{t('documents.trustpro-sync-now')}</Link>
                </span>
            </div>
        </div>
    );
};

export default TrustProSyncBanner;
